<template>
  <VAutocomplete
    v-model="data.clients"
    :label="$t('forms.labels.clients')"
    :items="displayedClients"
    :loading="clientsLoading"
    cacheItems
    :rules="{ required: true }"
    data-cy="clientAccessGroup"
    @search="debouncedClientSearch"
    @input="updateData"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import { debounce } from 'lodash';


export default {
    components: {
        VAutocomplete,
    },
    props: {
        accessGroups: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            clients: [],
            queryParams: {},
            debouncedClientSearch: debounce(this.searchClients, 500),
            data: {
                clients: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
        displayedClients() {
            return this.clients.map(({ id, name, accountNumber }) => ({
                id,
                name: `${name} [${accountNumber}]`,
            }));
        },
    },
    watch: {
        accessGroups: {
            handler() {
                this.data.accessGroups = [...this.accessGroups];
            },
            immediate: true,
        },
    },
    created() {
        this.getClients();
    },
    methods: {
        async getClients() {
            this.clientsLoading = true;
            const { data } = await this.$rq.getClients({ ...this.queryParams, allClients: true });
            this.clients = data.clients;
            this.clientsLoading = false;
        },
        async searchClients(search) {
            this.queryParams = { search };
            await this.getClients();
        },
        updateData(select) {
            this.$emit('sendData', { clientId: select });
        },
    },
};
</script>
